import { render, staticRenderFns } from "./ClientReferral.vue?vue&type=template&id=b5a27bf6&scoped=true&"
import script from "./ClientReferral.vue?vue&type=script&lang=js&"
export * from "./ClientReferral.vue?vue&type=script&lang=js&"
import style0 from "./ClientReferral.vue?vue&type=style&index=0&id=b5a27bf6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a27bf6",
  null
  
)

export default component.exports